import { gql } from '@apollo/client'
import { SHIPPING_FRAGMENT } from './ShippingFragment'

export const ADMIN_AUDIT_PRODUCT_FRAGMENT = gql`
  fragment AdminAuditProduct on Product {
    id
    upcA
    name
    commonName
    isActive
    shipping {
      ...Shipping
    }
  }
  ${SHIPPING_FRAGMENT}
`
